import axios from "axios";

// Every request to the admin API carries the admin's login — the server refuses
// all but a few public endpoints without it. Done once here, for axios and
// fetch alike, so no page can forget it. When the server says the login is no
// longer valid (expired, signed with an old secret, not an admin), the saved
// login is dropped and the admin is sent to the login screen.

const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
const LOGGED_OUT = new Set(["login_required", "invalid_token", "not_admin"]);

const isApi = (url) => !!API_URL && typeof url === "string" && url.startsWith(`${API_URL}/api/`);
const token = () => localStorage.getItem("accessToken");

let leaving = false;
function logOut() {
  if (leaving || !token()) return;          // already gone (or logging in): nothing to undo
  leaving = true;
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  window.location.replace("/");
}
const onRejected = (status, code) => {
  if ((status === 401 || status === 403) && LOGGED_OUT.has(code)) logOut();
};

// ─── axios ────────────────────────────────────────────────────────────────────
axios.interceptors.request.use((config) => {
  const url = config.baseURL && !/^https?:/.test(config.url || "") ? `${config.baseURL.replace(/\/+$/, "")}/${String(config.url || "").replace(/^\/+/, "")}` : config.url;
  const t = token();
  if (t && isApi(url) && !config.headers?.Authorization && !config.headers?.authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});
axios.interceptors.response.use(undefined, (error) => {
  onRejected(error.response?.status, error.response?.data?.code);
  return Promise.reject(error);
});

// ─── fetch ────────────────────────────────────────────────────────────────────
const nativeFetch = window.fetch.bind(window);
window.fetch = async (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url;
  const t = token();
  if (t && isApi(url)) {
    const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined) || {});
    if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${t}`);
    init = { ...init, headers };
  }
  const res = await nativeFetch(input, init);
  if (isApi(url) && (res.status === 401 || res.status === 403)) {
    res.clone().json().then((b) => onRejected(res.status, b?.code)).catch(() => {});
  }
  return res;
};
